import { Box } from "@mui/material";

import { PaymentOverview, WalletSummary } from "../../../payment.types";

import SummaryCard from "./SummaryCard";
import PaymentCard, { PaymentCardLoading } from "./PaymentCard";

const transformPaymentsObj = (payments?: PaymentOverview) => {
  if (!payments) return [];
  return Object.entries(payments).map(([key, value]) => ({
    key,
    ...value,
  }));
};

const transformWalletSummaryObj = (walletSummary?: WalletSummary) => {
  if (!walletSummary) return [];
  return Object.entries({
    totalTransferred: walletSummary.totalTransferred,
    pendingToUser: walletSummary.pendingToUser,
    platformCommission: walletSummary.platformCommission,
    paidToUser: walletSummary.paidToUser,
  }).map(([key, value]) => ({
    key,
    amount: value,
  }));
};

const PaymentOverviewCards = ({
  walletSummary,
  paymentOverviewData,
  isLoading,
}: {
  walletSummary?: WalletSummary;
  paymentOverviewData?: PaymentOverview;
  isLoading: boolean;
}) => {
  if (isLoading)
    return (
      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "repeat(2, 1fr)", sm: "repeat(4, 1fr)" }, gap: "16px" }}>
        {[...Array(4)].map((_, index) => (
          <PaymentCardLoading key={index} />
        ))}
      </Box>
    );
  const paymentsList = transformPaymentsObj(paymentOverviewData);
  const walletSummaryList = transformWalletSummaryObj(walletSummary);

  return (
    <Box sx={{ display: "grid", gridTemplateColumns: { xs: "repeat(2, 1fr)", md: "repeat(4, 1fr)" }, gap: "16px" }}>
      {/* {paymentsList.map((payment) => (
        <PaymentCard key={payment.key} payment={payment} />
      ))} */}
      {walletSummaryList.map((walletSummary) => (
        <SummaryCard key={walletSummary.key} summary={walletSummary} />
      ))}
    </Box>
  );
};

export default PaymentOverviewCards;
